import React from 'react'
import styled, { css } from 'styled-components'
import { string, bool } from 'prop-types'
import { stripUnit } from 'polished'

import * as spacing from 'styles/spacing'
import { media } from 'styles/media'
import { fontSizes } from 'styles/typography'
import { white, black } from 'styles/colors'

const Container = styled.a`
  backface-visibility: hidden;
  font-size: ${fontSizes.tiny};
  text-transform: uppercase;
  color: ${white};
  letter-spacing: 0.1em;
  text-align: center;

  ${props =>
    props.isLight &&
    css`
      color: ${black};
    `}

  ${media.medium`
    text-align: right;
  `};

  & + & {
    margin-top: ${stripUnit(spacing.small) * 1.5 + 'px'};

    ${media.medium`
      margin-top: ${stripUnit(spacing.medium) * 1.25 + 'px'};
    `};

    ${media.xLarge`
      margin-top: ${spacing.large};
    `};
  }
`

const SocialLink = ({ label, link, isLight, ...rest }) => (
  <Container isLight={isLight} href={link} target="_blank" {...rest}>
    {label}
  </Container>
)

SocialLink.propTypes = {
  label: string.isRequired,
  link: string.isRequired,
  isLight: bool
}

export default SocialLink
